import moment from "moment";
import math from 'mathjs';
const TYPES = require("../../../src-client-lib/api/type-ids.js");

/**
 *
 * expression: an expression of a function(ExpressionEvaluator.generateEvaluationFunction) that generates the final value
 * handler: a function that can modify raw data
 * confirmResponseTypeId: if request has confirm response, add response type id
 */

const serverSideFunctions = [
  {
    name: 'TSCalculate',
    expression: (sfo) => `datasets['${sfo.requestId}'].value`,
    handler: (request, data) => data[request.params[1]] = data.value,
    afterDataLoaded: (params, data) => {

      console.log(data);
      //
      // // handle emitEmptyWindow option
      // if (params[11] && data.length > 0) {
      //   let latest = data[0].value;
      //   data.forEach(d => {
      //     if (isNaN(d.value) && isNumeric(latest)) {
      //       d.value = latest;
      //     } else if (isNumeric(d.value)) {
      //       latest = d.value;
      //     }
      //   });
      //
      //   // remove NaN values
      //   data = data.filter(d => !isNaN(d.value));
      // }

      return data;
    }
  },
  {
    name: 'TSCalculateFilterByString',
    expression: (sfo) => `datasets['${sfo.requestId}'].value`,
    afterDataLoaded: (params, data) => {
      console.log(data);
      return data;
    }
  },
  {
    name: 'TSCalculateGroupBy',
    expression: (sfo) => `datasets['${sfo.requestId}'].value`,
    afterDataLoaded: (params, data) => {
      const functionType = params[6];
      const groupByTimeUnit = params[9];
      data = removeNaNData(data);
      console.log('TSCalculateGroupBy loaded');
      console.log(data);
      return consolidate(data, groupByTimeUnit, functionType);
    }
  },
  {
    name: 'TSCalculateMinMaxAvgMedian',
    expression: (sfo) => `datasets['${sfo.requestId}']`
  },
  {
    name: 'Latest',
    expression: (sfo) => {
      const field = sfo.params.length === 1 ? sfo.params[0].split('||')[1] : sfo.params[1];
      return `datasets['${sfo.requestId}'].${field}`;
    }
  },
  {
    name: 'GetDataAfterTime',
    confirmResponseTypeId: TYPES.GetDataAfterTimeResponse,
    expression: (sfo) => {
      const field = sfo.params[1];
      return `datasets['${sfo.requestId}'].${field}`;
    },
    afterDataLoaded: (params, data) => {
      console.group('GetDataAfterTime completed');
      console.log(data);
      console.groupEnd();
      return data;
    }
  },
  {
    name: 'GetDataAfterTimeForResolution',
    handler: (request, data) => data.value = data[request.params[1]],
    expression: (sfo) => {
      return `datasets['${sfo.requestId}'].value`;
    },
    afterDataLoaded: (params, data) => {
      console.group('GetDataAfterTimeForResolution completed');
      console.log(data);
      console.groupEnd();
      return data;
    }
  },
  {
    name: 'GetDataBeforeTime',
    handler: (request, data) => data.value = data[request.params[1]],
    expression: (sfo) => {
      return `datasets['${sfo.requestId}'].value`;
    },
    afterDataLoaded: (params, data) => {
      console.group('GetDataBeforeTime completed');
      console.log(data);
      console.groupEnd();
      return data;
    }
  },
  {
    name: 'GetDataForTimeRange',
    handler: (request, data) => data.value = data[request.params[1]],
    expression: (sfo) => {
      return `datasets['${sfo.requestId}'].value`;
    },
    afterDataLoaded: (params, data) => {
      console.group('GetDataForTimeRange completed');
      console.log(data);
      console.groupEnd();
      return data;
    }
  },
  {
    name: 'GetDatasetDoubleFieldByTimeRange',
    confirmResponseTypeId: TYPES.GetDataForTimeRangeResponse,
    handler: (request, data) => data.value = data[request.params[1]],
    expression: (sfo) => `datasets['${sfo.requestId}'].value`,
    afterDataLoaded: (params, data) => {
      console.group('GetDatasetDoubleFieldByTimeRange completed');
      console.log(data);
      console.groupEnd();
      return data;
    }
  },
  {
    name: 'CountFilterByString',
    expression: (sfo) => `datasets['${sfo.requestId}'].value`
  },
  {
    name: 'GetDataByRecordLocation',
    confirmResponseTypeId: TYPES.GetDataByRecordLocationResponse,
    handler: (request, data) => data.value = data[request.params[1]],
    expression: (sfo) => `datasets['${sfo.requestId}'].value`,
    afterDataLoaded: (params, data) => {
      console.group('GetDataByRecordLocation completed');
      console.log(data);
      console.groupEnd();
      return data;
    }
  },
];

const consolidate = (data, timeUnit = 2, functionType) => {
  const dataGroup = {};
  const today = moment();


  const currentYear = today.year();
  const currentMonth = today.month() + 1 < 10 ? '0' + (today.month() + 1) : today.month() + 1;
  let currentDate = today.date();

  data.forEach(d => {
    const m = moment(d.timestamp);
    let key;

    switch (parseInt(timeUnit)) {
      case HOUR: {
        let hour = m.hour();
        currentDate = today.date();

        // makes 00:00:00 at the end
        if (hour === 0) {
          currentDate = moment().add(1, 'days').date();
        }

        if (hour < 10) {
          hour = '0' + hour;
        }
        key = `${currentYear}-${currentMonth}-${currentDate} ${hour}:00:00`;
        break;
      }
      case DAY: {
        let date = m.date();
        if (date < 10) {
          date = '0' + date;
        }
        key = `${currentYear}-12-${date} 00:00:00`;
        break;
      }
      case MONTH: {
        let month = m.month() + 1;
        if (month < 10) {
          month = '0' + month;
        }
        key = `${currentYear}-${month}-${currentDate} 00:00:00`;
        break;
      }
      case DAY_OF_WEEK: {
        let dayOfWeek = m.day();
        // 2017-01-01 is Sunday
        key = `${currentYear}-${currentMonth}-0${dayOfWeek + 1} 00:00:00`;
      }
    }

    if (dataGroup.hasOwnProperty(key)) {
      dataGroup[key].push(d);
    } else {
      dataGroup[key] = [d];
    }
  });


  const calculatedData = [];
  for (let prop in dataGroup) {
    let value;
    const values = dataGroup[prop]
      .map(d => d.value);

    switch (parseInt(functionType)) {
      case 0: {
        // average
        let sum = values
          .reduce((previous, current) => current += previous);
        value = sum / dataGroup[prop].length;
        break;

      }
      case 1: {
        // low
        value = Math.min(...values);
        break;
      }
      case 2: {
        // high
        value = Math.max(...values);
        break;
      }
      case 3: {
        // close
        value = values.pop();
        break;
      }
      case 4: {
        // median
        value = median(values);
        break;
      }
    }

    const firstDataInGroup = JSON.parse(JSON.stringify(dataGroup[prop][0]));
    firstDataInGroup.timestamp = new Date(prop).getTime();
    firstDataInGroup.epochSecond = firstDataInGroup.timestamp / 1000;
    firstDataInGroup.value = value;
    calculatedData.push(firstDataInGroup)
  }

  return calculatedData;
};

const getServerSideFunction = (name) => {
  const functions = serverSideFunctions.filter(s => s.name === name.trim());
  return functions.length === 1 ? functions[0] : null;
};

const removeNaNData = (data) => {
  return data.filter(d => !isNaN(d.value));
};

const fillEmptyTimeslotData = (data, startTime, endTime, timeWindowQuantity, timeWindowUnit) => {
};

const timeUnitInMillis = (timeUnit) => {
  switch (timeUnit) {
    case 0: {
      return 1000;
    }
    case 1: {
      return 1000 * 60;
    }
    case 2: {
      return 1000 * 60 * 60;
    }
    case 3: {
      return 1000 * 60 * 60 * 24;
    }
    case 4: {
      return 1000 * 60 * 60 * 24 * 7;
    }
    case 5: {
      return 1000 * 60 * 60 * 24 * 30;
    }
    case 6: {
      return 1000 * 60 * 60 * 24 * 365;
    }
    case 7: {
      return 1;
    }
  }
};

export {serverSideFunctions, getServerSideFunction};

function median(numbers) {
  var median = 0, numsLen = numbers.length;
  numbers.sort();
  if (
    numsLen % 2 === 0
  ) {
    median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
  } else {
    median = numbers[(numsLen - 1) / 2];
  }
  return median;
}


// WEBPACK FOOTER //
// ./src/core/constants/serverSideFunctionList.js